import * as React from 'react';
import { Avatar, Body1, UIHeading4 } from '@cian/ui-kit';

import { IDeveloperCell } from '../../../../../../types/newbuildingsCompare';
import { trackCheckDeveloperInfoEvent } from '../tracking';
import { getDeveloperLink } from './getDeveloperLink';
import * as style from './style.css';

export interface IDeveloperCellDesktopProps {
  cell: IDeveloperCell;
}

export const DeveloperCellDesktop = ({ cell }: IDeveloperCellDesktopProps): React.JSX.Element => {
  const developerLink = getDeveloperLink(cell.data?.id);

  return (
    <div className={style['container']}>
      <div className={style['image-wrapper']}>
        <Avatar size={56} src={cell.data?.logoUrl} type="builder" hideBorder />
      </div>
      <a
        className={style['developer-name-link']}
        href={developerLink}
        onClick={trackCheckDeveloperInfoEvent}
        target="blank"
      >
        <UIHeading4 color="current_color">{cell.data?.name}</UIHeading4>
      </a>
      <div className={style['developer-info']}>
        <Body1>{cell.data?.workSinceText}</Body1>
        <Body1>{cell.data?.doneHousesText}</Body1>
        <Body1>{cell.data?.inProgressHousesText}</Body1>
      </div>
    </div>
  );
};
